import { render, staticRenderFns } from "./BasicInfoConfig.vue?vue&type=template&id=73828c01&"
import script from "./BasicInfoConfig.vue?vue&type=script&lang=js&"
export * from "./BasicInfoConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports